import * as React from 'react';
export const apiSvg = React.forwardRef(function apiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.5 2.4h-7a1.1 1.1 0 0 0-1.1 1.1v5a1.1 1.1 0 0 0 1.1 1.1h7a1.1 1.1 0 0 0 1.1-1.1v-5a1.1 1.1 0 0 0-1.1-1.1ZM2.5 1A2.5 2.5 0 0 0 0 3.5v5A2.5 2.5 0 0 0 2.5 11h7A2.5 2.5 0 0 0 12 8.5v-5A2.5 2.5 0 0 0 9.5 1h-7Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.005 3.705a.7.7 0 0 1 .99 0l1.8 1.8a.7.7 0 0 1 0 .99l-1.8 1.8a.7.7 0 0 1-.99-.99L4.31 6 3.005 4.695a.7.7 0 0 1 0-.99ZM5.8 7.7a.7.7 0 0 1 .7-.7h1.8a.7.7 0 1 1 0 1.4H6.5a.7.7 0 0 1-.7-.7Z',
    }),
  );
});
apiSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var api = {
  category: 'icon',
  colorable: true,
  name: 'api',
  svg: apiSvg,
};
